export const blockIconsTextformattingDashboardNew = (
	<span className='material-symbols-outlined'>dashboard</span>
);
